/* global FavoritesEnabled, SeasonPagesEnabled */
/* eslint-disable react/jsx-no-bind */

// TODO: Remove SeriesDetail and replace with ContentDensity => CPEWEB-3795
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { StickyContainer } from 'react-sticky';
import { Waypoint } from 'react-waypoint';
import { Element, Events } from 'react-scroll';
import ReactTimeout from 'react-timeout';
import _ from 'lodash';
import classNames from 'classnames';
import Tile from 'components/TileLegacy';
import VideoHero from 'components/VideoHero';
import Favorite, {
  FAVORITE_TYPE_LINK,
  FAVORITE_TYPE_ICON,
  FAVORITE_PLUS_CIRCLE,
  FAVORITE_HEART,
  FAVORITE_TEXT_POSITION_LEFT,
  FAVORITE_TEXT_POSITION_RIGHT,
} from 'components/Favorite';
import { setFirstPage } from 'components/Panel/PanelActions';
import ContextPlayer from 'components/ContextPlayer';
import { noop } from 'helpers/GlobalHelper';
import { createSchemaTag, createSeriesDetailSchema } from 'helpers/SchemaHelper';
import {
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_MOBILE,
} from 'helpers/BreakpointHelper';
import { isNationEntitled, seriesAnonymousEnabled } from 'helpers/ConfigHelper';
import {
  getDisplayBrand,
  getErrorComponent,
  getShowType,
  getSocialLinksFromContent,
  getUrlTarget,
  isClip,
  isEpisode,
  isStaticRender,
  LINK_REL,
  PAGE_TYPE_ARTICLE,
  PAGE_TYPE_CREDITS,
  PAGE_TYPE_PROMO_LIST,
} from 'helpers/ContentHelper';
import {
  SHOW_DETAIL_THUMBNAIL_IMAGE,
  SHOW_DETAIL_HERO_IMAGE,
  renderImage,
} from 'helpers/ImageHelper';
import { brandOverrideMetaTags, setHelmetTags } from 'helpers/HelmetHelper';
import {
  seriesVideoProcessor,
  clipsVideoProcessor,
  seriesCollectionVideoProcessor,
  prePremiereVideoProcessor,
} from 'helpers/VideoProcessorHelper';

import {
  BUILD_VERSION,
  callTealiumEvent,
  Events as SegmentEvents,
  getFavoritesListString,
  getTealiumDetailTabData,
  getTealiumSourceCollectionGlobal,
  handleAnalytics,
  PageNames,
  SegmentSources,
  setSegmentContentPersonality,
  setTealiumProfileId,
  setTealiumProfileStartSource,
  setTealiumSourceAuth,
  setTealiumSourceCollectionGlobal,
  tealiumEventPageTypes,
  TEALIUM_EVENT_PREFIX,
  trackPageReferrerAnalytics,
} from '@foxcorp/delta-web-analytics';
import { redirectToExternalUrl, helperGetRelativeUrl } from 'helpers/RouteHelper';
import { deepLinkFavoriteSeries, getCommonTealiumProps } from 'helpers/AccountHelper';
import Article from 'components/Article';
import BreadcrumbsComponent, { breadcrumbsSeriesDetailParser } from 'components/Breadcrumbs';
import Carousel from 'components/Carousel';
import PromoList from 'components/PromoList';
import { saveLiveVideo } from 'screens/Live/LiveActions';
import { fetchArticle } from 'components/Article/ArticleActions';
import { getArticleApiUrl } from 'components/Article/ArticleHelpers';
import { getPromoListApiUrl } from 'components/PromoList/PromoListHelpers';
import Loader from 'components/Loader';
import { setRecommendationIdAction as setRecommendationId } from 'index/AppActions';
import BioComponent from './components/Bio';
import BrandingComponent from './components/Branding';
import TabListComponent from './components/TabList';
import VideosTabComponent from './components/VideosTab';
import PhotoGalleryComponent from './components/PhotoGallery';
import PersonalityBio from './components/PersonalityBio';
import {
  fetchAnonymousCategoryDetail,
  fetchAnonymousSeries,
  fetchCategoryDetail,
  fetchSeries,
  clearSeriesDetail,
  setSeriesDetailError,
} from './SeriesDetailActions';
import { fetchVideosTab } from './components/VideosTab/VideosTabActions';
import {
  getCreditIdFromUrl,
  getCTAUrl,
  getFeaturedBio,
  getPromoData,
  getSelectedTabIndex,
  getTabDataUrl,
  getTabName,
  getTabSlug,
  hasPrePremiereVideo,
  isContinueWatchingComponent,
  isCreditsItem,
  isInlineComponent,
  isPlaylist,
  isPromoItem,
  isTabGrouped,
  isSeriesCollection,
  NO_TAB_STATE_TRAILER,
  SERIES_TYPE_SERIES_COLLECTION,
  SERIES_SCROLL_ELEMENT,
  ARTICLE_SCROLL_ELEMENT,
  PROMO_TYPE_FEATURED_OVERRIDE,
  PROMO_TYPE_HEADER,
  PROMO_TYPE_LEAD,
  SERIES_TYPE_CREDITS,
  PROMO_TYPE_GALLERY,
} from './SeriesDetailHelpers';
import { getPersonalityTabSlug } from './PersonalityDetailHelpers';
import style from './styles/SeriesDetail.css';
import articleTheme from './styles/Article.css';
import CarouselPosterTheme from './styles/SeriesDetailsCarouselPoster.module.scss';
import CarouselTheme from './styles/SeriesDetailsCarousel.module.scss';
import CarouselTileTheme from './styles/SeriesDetailsCarouselTile.module.scss';
import { fetchBioDetail, fetchBioLanding } from './components/Bio/BioActions';

import NationWhatIs from './components/NationWhatIs';
import StartFreeTrial from './components/StartFreeTrial';
import {
  makeSelectSeriesDetailSeriesData,
  makeSelectSeriesDetailInline,
  makeSelectSeriesDetailTabs,
  makeSelectSeriesDetailLatestEpisode,
  makeSelectSeriesDetailPromos,
  makeSelectSeriesDetailSeo,
} from './selectors';
import HeadlineBumper from './components/HeadlineBumper';

const { DETAIL, FAVORITES_DETAIL, SERIES_DETAIL } = PageNames;

const FETCH_NEW_CONTENT_INTERVAL_MS = 1000 * 60 * 30;

const BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: {
    actionButtonsInHeader: false,
    actionButtonsInNav: true,
    addCarouselPlaceholders: true,
    allowScrollLock: false,
    applyInlineBackground: true,
    backgroundImagePath: 'images.seriesDetail.raw',
    brandingTitleClampSize: 0,
    carouselLimit: 4,
    posterLimit: 5,
    posterToScroll: 5,
    renderAltHeader: false,
    roundArrows: true,
    showCarouselArrows: true,
    showLogoPath: 'images.logo.raw',
    showTileMetadataOnHover: true,
    slidesToScroll: 4,
    socialLinks: true,
    tabsInAltHeader: false,
    useScrollableDiv: false,
    videoBackground: true,
  },
  [SITE_PLATFORM_WEB]: {
    actionButtonsInHeader: false,
    actionButtonsInNav: true,
    addCarouselPlaceholders: true,
    allowScrollLock: false,
    applyInlineBackground: true,
    backgroundImagePath: 'images.seriesDetail.raw',
    brandingTitleClampSize: 0,
    carouselLimit: 3,
    descriptionLines: 5,
    posterLimit: 5,
    posterToScroll: 5,
    renderAltHeader: false,
    roundArrows: true,
    showCarouselArrows: true,
    showLogoPath: 'images.logo.raw',
    showTileMetadataOnHover: true,
    slidesToScroll: 3,
    socialLinks: true,
    tabsInAltHeader: false,
    useScrollableDiv: false,
    useSeriesLogo: true,
    videoBackground: true,
  },
  [SITE_PLATFORM_TABLET]: {
    actionButtonsInHeader: true,
    actionButtonsInNav: false,
    addCarouselPlaceholders: true,
    allowScrollLock: false,
    applyInlineBackground: true,
    backgroundImagePath: 'images.seriesDetail.raw',
    brandingTitleClampSize: 4,
    carouselLimit: 2,
    descriptionLines: 5,
    posterLimit: 3,
    posterToScroll: 3,
    renderAltHeader: false,
    roundArrows: true,
    showCarouselArrows: true,
    showLogoPath: 'images.logoCenter.raw',
    showTileMetadataOnHover: true,
    slidesToScroll: 2,
    socialLinks: false,
    tabsInAltHeader: true,
    useScrollableDiv: false,
    useSeriesLogo: true,
    videoBackground: false,
  },
  [SITE_PLATFORM_MOBILE]: {
    actionButtonsInHeader: true,
    actionButtonsInNav: false,
    addCarouselPlaceholders: false,
    allowScrollLock: false,
    applyInlineBackground: true,
    backgroundImagePath: 'images.seriesDetail.raw',
    brandingTitleClampSize: 3,
    carouselLimit: 2,
    descriptionLines: 5,
    posterLimit: 3,
    posterToScroll: 3,
    renderAltHeader: false,
    roundArrows: true,
    showCarouselArrows: true,
    showLogoPath: 'images.logoCenter.raw',
    showTileMetadataOnHover: false,
    slidesToScroll: 2,
    socialLinks: false,
    tabsInAltHeader: true,
    useScrollableDiv: true,
  },
};

class SeriesDetail extends Component {
  constructor(props) {
    super(props);
    const isPersonality = _.get(props, 'route.params.fetchFromCategories', false);
    const renderAsAnonymous = seriesAnonymousEnabled() && !isNationEntitled();

    this.state = {
      breakpoint: SITE_PLATFORM_WEB,
      contextPlayerVisibility: false,
      deepLinkFavorited: false,
      isBrandingClicked: false,
      isPersonality,
      playlist: false,
      renderAsAnonymous,
      scrolling: false,
      stickyHeader: false,
      trackedAnalyticsReferrer: false,
    };

    this.trackPageReferrerAnalytics = trackPageReferrerAnalytics.bind(this);
    this.deepLinkFavoriteSeries = deepLinkFavoriteSeries.bind(this);
    this.setDeepLinkFavorited = this.setDeepLinkFavorited.bind(this);
  }

  componentDidMount() {
    this.fetchInitialData();
    this.trackPageView();
    Events.scrollEvent.register('begin', this.scrollStart);
    Events.scrollEvent.register('end', this.scrollEnd);

    if (isNationEntitled()) this.setState({ renderAsAnonymous: false });
  }

  componentDidUpdate(prevProps) {
    const {
      params: { showId: prevShowId },
      tabs: prevTabs,
      errors: prevErrors,
    } = prevProps;

    const {
      accessToken,
      deviceId,
      errors,
      clearSeriesDetail,
      fetchCategoryDetail,
      fetchSeries,
      params: { showId },
      tabs,
    } = this.props;

    const fetchNewSeries = prevShowId !== showId && prevShowId && showId;
    const newErrors = !prevErrors && errors;
    const newTabs = !prevTabs && tabs;
    const firePageView = newTabs || newErrors;
    if (fetchNewSeries) {
      const fetchFromCategories = _.get(this.props, 'route.params.fetchFromCategories');
      clearSeriesDetail();
      if (fetchFromCategories) {
        fetchCategoryDetail(showId, accessToken, deviceId);
      } else {
        fetchSeries(showId, accessToken, deviceId);
      }
    }
    if (firePageView) this.trackPageView();
  }

  componentWillUnmount() {
    const { clearSeriesDetail, disableScroll } = this.props;
    this.trackPageReferrerAnalytics({
      name: SERIES_DETAIL,
    });
    setSegmentContentPersonality(false);
    clearSeriesDetail();
    disableScroll({ disableScroll: false, bodyOnly: false });
  }

  scrollStart = () => {
    this.setState({ scrolling: true });
  };

  scrollEnd = () => {
    this.setState({ scrolling: false });
  };

  getBreadcrumbsData() {
    const { params, seriesData, articlePanels, bioProfiles } = this.props;
    const { isPersonality } = this.state;
    const { pageId } = params;
    const articleData = _.get(articlePanels, 'member.0.items.member.0', null);
    const creditsData = getFeaturedBio(pageId, bioProfiles);
    const breadcrumbsData = breadcrumbsSeriesDetailParser(
      params,
      seriesData,
      articleData,
      creditsData,
      isPersonality,
    );
    return breadcrumbsData;
  }

  getCurrentTabIndex() {
    const pageId = this.getPageId();
    const { tabs } = this.props;
    const { isPersonality } = this.state;

    if (!tabs) return false;
    const seriesType = this.getSeriesType();
    const noTabState = this.noTabState();
    const noTabHomepage = this.noTabHomepage();

    const { tabIndex, subTabIndex } = getSelectedTabIndex({
      isPersonality,
      pageId,
      tabs,
      noTabState,
      noTabHomepage,
      seriesType,
    });
    return { tabIndex, subTabIndex };
  }

  getHeroImage() {
    const { breakpoint, latestEpisode, seriesData } = this.props;
    const { backgroundImagePath } = BREAKPOINTS[breakpoint];
    const { inline } = this.props;
    const { isPersonality, renderAsAnonymous } = this.state;
    let inlineContent = latestEpisode || _.get(inline, 'items.member.0') || inline;
    if (isPersonality) inlineContent = inline;

    const anonymousImage =
      _.get(seriesData, 'images.seriesDetailUnauth.FHD') ||
      _.get(seriesData, 'images.seriesDetail.FHD') ||
      _.get(inlineContent, 'autoPlayStill.default.FHD') ||
      _.get(inlineContent, 'images.FHD') ||
      _.get(inlineContent, 'images.still.FHD');

    let image =
      _.get(inlineContent, backgroundImagePath) ||
      _.get(inlineContent, 'autoPlayStill.default.url') ||
      _.get(inlineContent, 'images.raw') ||
      _.get(inlineContent, 'images.still.raw');

    if (breakpoint === SITE_PLATFORM_MOBILE || breakpoint === SITE_PLATFORM_TABLET) {
      image = _.get(seriesData, 'images.still.raw', image);
    }

    const useAnonymous = renderAsAnonymous && anonymousImage;
    return useAnonymous ? anonymousImage : image;
  }

  getPageId() {
    const {
      params: { pageId, pageType },
    } = this.props;
    if (pageType && pageId) return `${pageType}/${pageId}`;
    return pageId || pageType;
  }

  getPlaylistId() {
    const { tabs } = this.props;
    const { tabIndex } = this.getCurrentTabIndex();
    if (!tabs || tabIndex === false) return null;
    const tab = tabs[tabIndex];
    const id = _.get(tab, 'id');
    if (!isPlaylist(tab)) return null;
    return id;
  }

  getPromoTypeHeaderCta() {
    const { promos } = this.props;
    if (!promos) return null;

    const headerItems = _.get(promos, 'items.member', []).filter(
      item => item.promoType === PROMO_TYPE_HEADER,
    );
    const header = _.get(headerItems, '0', null);
    return header;
  }

  getSEO() {
    const { seo, tabs } = this.props;
    const { tabIndex } = this.getCurrentTabIndex();
    if (!tabs || tabIndex === false) return seo;
    const tab = tabs[tabIndex];
    const tabSEO = _.get(tab, 'SEOV2', {});
    return { ...seo, ...tabSEO };
  }

  getSeriesType() {
    const { inline } = this.props;
    const inlineContent = _.get(inline, 'items.member.0', null);
    return _.get(inlineContent, 'seriesType', null);
  }

  getVideo() {
    const { breakpoint, latestEpisode } = this.props;
    const { videoBackground } = BREAKPOINTS[breakpoint];
    const { inline } = this.props;
    const inlineContent = latestEpisode || _.get(inline, 'items.member.0');
    const video = videoBackground && _.get(inlineContent, 'autoPlayVideo.default.url');

    return video;
  }

  getVideoHeroProps() {
    const { overlay } = this.props;
    const { stickyHeader, renderAsAnonymous } = this.state;
    const video = this.getVideo();
    const image = this.getHeroImage();
    if (!video && !image) return null;
    const props = {
      video,
      timer: 5,
      image,
      load: true,
      play: true,
      loop: true,
      fadeImageToVideo: true,
      addShadowOverlay: renderAsAnonymous,
    };
    if (overlay || stickyHeader || renderAsAnonymous) {
      props.play = false;
    }
    return props;
  }

  setErrors = errors => {
    const { setSeriesDetailError } = this.props;
    setSeriesDetailError(errors);
  };

  setOverrideMetatags() {
    const { seriesData } = this.props;
    const { isPersonality } = this.state;
    const network = _.get(seriesData, 'network');
    const brandOverride = brandOverrideMetaTags(network);
    if (brandOverride && !isPersonality) return brandOverride;
    return null;
  }

  setDeepLinkFavorited(value) {
    return this.setState({ deepLinkFavorited: value });
  }

  selectMenuItemEvent = ({ title, subtitle }) => {
    const { tabs } = this.props;
    const { tabIndex } = this.getCurrentTabIndex();
    const seriesType = this.getSeriesType();
    const currentTabName = getTabName({ tab: tabs[tabIndex], seriesType });
    handleAnalytics({
      event: SegmentEvents.MENU_ITEM_SELECTED,
      payload: {
        page_category_title: currentTabName,
        page_item_title: title,
        page_item_subtitle: subtitle,
      },
    });
  };

  togglePlaylist = () => {
    const { playlist } = this.state;
    this.setState({ playlist: !playlist });
  };

  tealiumAuthStart = () => {
    const { account } = this.props;
    const action = 'authentication_start';
    const profileId = _.get(account, 'profileId');
    const authStartSource = 'series_detail_page';
    setTealiumSourceAuth(authStartSource);
    setTealiumProfileStartSource('detail page');
    const data = setTealiumProfileId(profileId, {
      action,
      auth_start_source: authStartSource,
      dcg_profile_id: profileId,
      platform_version: BUILD_VERSION,
      profile_start_source: 'detail page',
      ...getCommonTealiumProps(),
    });
    callTealiumEvent(`${TEALIUM_EVENT_PREFIX}${action}`, data);
    setTealiumSourceAuth(authStartSource);
  };

  stickyHeaderCallback = isSticky => {
    this.setState({ ...this.state, stickyHeader: isSticky });
  };

  setIsBrandingClicked = isBrandingClicked => {
    this.setState({ isBrandingClicked });
  };

  trackPageView = () => {
    const {
      pageViewEvent,
      tabs,
      seriesData,
      seriesType,
      getUseUtagGlobal,
      errors,
      favoritesManager: { favorites },
    } = this.props;
    const { isPersonality } = this.state;
    if (!seriesData) return;
    const tab = _.get(tabs, '0');
    const pageTitle = _.get(seriesData, 'name');

    if ((tab || errors) && pageViewEvent) {
      const referringCollection = getTealiumSourceCollectionGlobal();
      const seriesCollection = getTealiumDetailTabData({ seriesData, tab });
      const selectedMenuItem = _.get(seriesCollection, 'selectedMenuItem');
      const categoryType = _.get(seriesData, 'categoryType');
      const pageType = `detail:${categoryType}`;

      if (isPersonality) {
        handleAnalytics(
          {
            event: SegmentEvents.DETAIL_PAGE_MENU_ITEM_VIEW,
            payload: {
              pageName: `detail:${pageType}:${categoryType}:${pageTitle}`,
              pageType: `detail:${pageType}:menu`,
              selectedMenuItem,
            },
          },
          {
            event: SegmentEvents.DETAIL_PAGE_DEFAULT_STATE,
            payload: {
              pageName: `${pageType}:${pageTitle}`,
              pageType: `${pageType}:landing`,
              pageCollectionTitle: referringCollection ? referringCollection.name : null,
              pageCollectionType: referringCollection
                ? referringCollection.collectionType
                : 'no collection type',
              ...(favorites && {
                favoritesContentLength: favorites.length,
                favoritesContentList: getFavoritesListString(favorites),
              }),
            },
          },
        );
      }

      if (referringCollection) {
        const { name: title } = referringCollection;
        setTealiumSourceCollectionGlobal({ ...referringCollection, title });
      }

      const collection = referringCollection;

      pageViewEvent({
        pageName: DETAIL,
        collection,
        useUtagGlobal: getUseUtagGlobal(),
        seriesType: isPersonality ? 'personality' : seriesType,
        pageTitle,
        pageType: `${pageType}:landing`,
        selectedMenuItem,
      });
      // Fire after page view event
      const hasFavorite = !!_.filter(favorites, { showCode: seriesData.showCode })[0];
      if (!hasFavorite)
        this.deepLinkFavoriteSeries({
          props: this.props,
          setDeepLinkFavorited: this.setDeepLinkFavorited,
        });
    }
  };

  brandingBackground = () => {
    const { breakpoint, setVideoHero, removeVideoHero } = this.props;
    const { renderAsAnonymous } = this.state;
    const { backgroundVideoLoops } = window.ExternalConfig;
    const video = this.getVideo();
    const image = this.getHeroImage();
    if ((video && !renderAsAnonymous) || !image) return null;
    return (
      <VideoHero
        backgroundVideoLoops={backgroundVideoLoops}
        id="branding-bg"
        {...this.getVideoHeroProps()}
        video={null}
        renderImage={imageProps =>
          renderImage({
            breakpoint,
            imageType: SHOW_DETAIL_HERO_IMAGE,
            ...imageProps,
          })
        }
        anonymousView={renderAsAnonymous}
        className={style.brandingBackground}
        onMount={setVideoHero}
        onUnmount={removeVideoHero}
      />
    );
  };

  controlVideoPlayback(inRange) {
    const { stickyHeader } = this.state;
    if (inRange && stickyHeader === true) {
      this.setState({ stickyHeader: false });
    } else if (!inRange && !stickyHeader) {
      this.setState({ stickyHeader: true });
    }
  }

  fetchInitialData() {
    if (isStaticRender()) return;
    const { renderAsAnonymous } = this.state;
    const {
      accessToken,
      deviceId,
      fetchAnonymousCategoryDetail,
      fetchAnonymousSeries,
      fetchCategoryDetail,
      fetchSeries,
      params: { showId },
      setInterval,
    } = this.props;
    const fetchFromCategories = _.get(this.props, 'route.params.fetchFromCategories');
    if (fetchFromCategories && renderAsAnonymous) {
      fetchAnonymousCategoryDetail(showId, accessToken, deviceId);
    } else if (fetchFromCategories) {
      fetchCategoryDetail(showId, accessToken, deviceId);
      setInterval(() => {
        const { accessToken: currentAccessToken } = this.props;
        fetchCategoryDetail(showId, currentAccessToken, deviceId);
      }, FETCH_NEW_CONTENT_INTERVAL_MS);
    } else if (renderAsAnonymous) {
      fetchAnonymousSeries(showId, accessToken, deviceId);
    } else {
      fetchSeries(showId, accessToken, deviceId);
      setInterval(() => {
        const {
          accessToken: currentAccessToken,
          deviceId: currentDeviceId,
          params: { showId },
        } = this.props;
        fetchSeries(showId, currentAccessToken, currentDeviceId);
      }, FETCH_NEW_CONTENT_INTERVAL_MS);
    }
  }

  isCreditsPageType() {
    return _.get(this.props, 'pageType') === SERIES_TYPE_CREDITS;
  }

  noTabHomepage() {
    const { inline } = this.props;
    const hasTrailer = hasPrePremiereVideo(inline);
    const trailer = _.get(inline, 'items.member.0.previewVideo.member.0', false);
    if (hasTrailer && trailer && trailer.name) return NO_TAB_STATE_TRAILER;
    return null;
  }

  noTabState() {
    const pageId = this.getPageId();
    const noTabHomepage = this.noTabHomepage();
    if (!pageId && noTabHomepage) return noTabHomepage;
    return null;
  }

  renderArticle() {
    const {
      params: { showId, pageType, pageId },
      accessToken,
      deviceId,
      pageViewEvent,
      setLoading,
    } = this.props;

    if (!pageId || pageType !== PAGE_TYPE_ARTICLE) return null;

    const articleUrl = getArticleApiUrl(pageId);

    return (
      <div className={style.screen}>
        <div className={style.article}>
          <Article
            url={articleUrl}
            accessToken={accessToken}
            deviceId={deviceId}
            pageViewEvent={pageViewEvent}
            scrollElement={ARTICLE_SCROLL_ELEMENT}
            setErrors={this.setErrors}
            setLoading={setLoading}
            showId={showId}
          />
        </div>
      </div>
    );
  }

  renderCredits() {
    const {
      accessToken,
      deviceId,
      params: { showId, pageId },
      breakpoint,
      setLoading,
      tabs,
    } = this.props;
    const creditsTab = _.find(tabs, tab => isCreditsItem(tab));
    const credits = _.get(creditsTab, 'member', []);
    const itemId = getCreditIdFromUrl({ credits, pageId });
    return (
      <BioComponent
        accessToken={accessToken}
        breakpoint={breakpoint}
        deviceId={deviceId}
        itemId={itemId}
        setLoading={setLoading}
        setErrors={this.setErrors}
        showId={showId}
        selectMenuItemEvent={this.selectMenuItemEvent}
      />
    );
  }

  renderFavorite(favoriteType) {
    const {
      params: { showId: showID },
      seriesData,
      favoritesManager,
      favoritableItems,
      recommendationId,
      tabs,
    } = this.props;

    const {
      global_favoriteButton: defaultText,
      global_favoriteSetButton: favoritedText,
    } = window.Language;

    const { deepLinkFavorited } = this.state;
    const { network, categoryType, seriesType, name: seriesName } = seriesData;
    const showType = getShowType({ seriesType });
    const hasTabs = tabs && tabs.length > 0;
    if (!FavoritesEnabled || !hasTabs) return null;
    const isPersonality = categoryType && categoryType === 'personality';
    const favorites = _.get(favoritesManager, 'favorites');
    const favoriteData = {
      actionLocation: _.get(tealiumEventPageTypes, DETAIL),
      favoriteType: isPersonality ? 'personality' : showType,
      favoritableItems,
      showID,
      source: SegmentSources.DETAIL,
      location: _.get(tealiumEventPageTypes, FAVORITES_DETAIL),
      networkId: network,
      seriesName,
      recommendationId,
    };
    return (
      <Favorite
        data={favoriteData}
        favorites={favorites}
        manager={favoritesManager}
        manuallySetFavorite={deepLinkFavorited}
        type={favoriteType}
        textPosition={!isPersonality ? FAVORITE_TEXT_POSITION_LEFT : FAVORITE_TEXT_POSITION_RIGHT}
        defaultText={!isPersonality ? defaultText : 'Favorite'}
        favoritedText={!isPersonality ? favoritedText : 'My Favorite'}
        iconType={!isPersonality ? FAVORITE_PLUS_CIRCLE : FAVORITE_HEART}
      />
    );
  }

  renderFeaturedPromo() {
    const { promos } = this.props;
    const items = _.orderBy(
      _.get(promos, 'items.member', []),
      promo => new Date(promo.dateModified),
      ['desc'],
    );
    const promo = _.find(items, item => item.promoType === PROMO_TYPE_FEATURED_OVERRIDE);
    if (!promo) return null;

    const renderCTA = ({ ctaText, url }) => {
      const { target, rel } = getUrlTarget(url);
      if (ctaText && url) {
        return (
          <div className={style.ctaButtonContainer}>
            <Link href={getCTAUrl(url)} target={target} rel={rel} className={style.ctaButton}>
              <p className={style.ctaButtonText}>{ctaText}</p>
            </Link>
          </div>
        );
      }
      return null;
    };

    const { headline, description, ctaText, url } = promo;

    return (
      <div className={style.featuredPromo}>
        <div className={style.featuredPromoHeadline}>{headline}</div>
        <div className={style.featuredPromoDesc}>{description}</div>
        {renderCTA({ ctaText, url })}
      </div>
    );
  }

  renderInline() {
    const pageId = this.getPageId();
    const {
      inline,
      isHeader,
      params: { showId, pageType },
      tabs,
      setOverlay,
      breakpoint,
      overlay,
      disableScroll,
      seriesData,
    } = this.props;
    const { isBrandingClicked, isPersonality, playlist, renderAsAnonymous } = this.state;
    const headlineIsPrimary = pageType !== PAGE_TYPE_CREDITS && pageType !== PAGE_TYPE_ARTICLE;
    if (!inline || inline.length === 0) return null;
    const previewButtonClick = () => {
      this.setState({ contextPlayerVisibility: true }, () =>
        disableScroll({ disableScroll: true, bodyOnly: true }),
      );
    };
    const trailer =
      _.get(seriesData, 'previewVideo.member.0') ||
      _.get(inline, '0.items.member.0.previewVideo.@populated');
    const hasTrailer = _.get(trailer, '@populated', false) || hasPrePremiereVideo(inline);
    const votingCTA = this.getPromoTypeHeaderCta();
    const {
      actionButtonsInHeader,
      brandingTitleClampSize,
      renderAltHeader,
      showLogoPath,
      tabsInAltHeader,
    } = BREAKPOINTS[breakpoint];
    const tabList =
      !tabsInAltHeader || !tabs || renderAsAnonymous ? null : (
        <TabListComponent
          {...{
            showId,
            pageId,
            tabs,
            isBrandingClicked,
            inline,
            setOverlay,
            breakpoint,
            overlay,
            favoriteButton: this.renderFavorite(FAVORITE_TYPE_ICON),
            socialLinks: this.renderSocialLinks(false),
            seriesType: this.getSeriesType(),
            setIsBrandingClicked: this.setIsBrandingClicked,
            togglePlaylist: this.togglePlaylist,
            playlist,
          }}
        />
      );
    const { id: panelId, items } = inline;
    const item = isPersonality ? inline : _.get(items, 'member.0', null);
    if (!item) return null;
    const { name, tuneIn, screenUrl } = item;
    const displayBrand = getDisplayBrand(item);
    let showLogo = _.get(item, `latestEpisode.${showLogoPath}`, null);

    if (!showLogo) showLogo = _.get(item, showLogoPath, null);

    return (
      <div key={`show-branding-${panelId}`}>
        <Waypoint
          onEnter={this.controlVideoPlayback.bind(this, true)}
          onLeave={this.controlVideoPlayback.bind(this, false)}
        />
        <BrandingComponent
          breakpoint={breakpoint}
          className={style.branding}
          containerClassName={style.screenElement}
          key={panelId}
          isHeader={isHeader}
          name={name}
          titleClampSize={brandingTitleClampSize}
          tuneIn={tuneIn}
          network={displayBrand}
          showLogo={showLogo}
          renderBackground={this.brandingBackground}
          stickyHeaderCallback={this.stickyHeaderCallback}
          showActionButtons={actionButtonsInHeader}
          favoriteButton={this.renderFavorite(FAVORITE_TYPE_ICON)}
          screenUrl={screenUrl}
          renderAltHeader={renderAltHeader}
          votingCTA={votingCTA}
          headlineIsPrimary={headlineIsPrimary}
          isPersonality={isPersonality}
          onClick={() => this.setIsBrandingClicked(true)}
          isAnonymous={renderAsAnonymous}
          item={item}
          hasTrailer={hasTrailer}
          previewButtonClick={previewButtonClick}
        >
          {tabList}
        </BrandingComponent>
      </div>
    );
  }

  renderPanel(panel, isPosters, renderDivider) {
    const { breakpoint, inline, seriesType, promos } = this.props;
    const { renderAsAnonymous } = this.state;
    const {
      addCarouselPlaceholders,
      allowScrollLock,
      applyInlineBackground,
      carouselLimit,
      posterLimit,
      posterToScroll,
      roundArrows,
      slidesToScroll,
      showCarouselArrows,
      showTileMetadataOnHover,
      useScrollableDiv,
    } = BREAKPOINTS[breakpoint];
    const name = _.get(panel, 'name');
    const headline = _.get(panel, 'headline', name);
    const items = _.get(panel, 'items.member');
    const promoLeadData = getPromoData({ data: promos, promoType: PROMO_TYPE_LEAD });
    const promoLeadContent = _.get(promoLeadData, 'items.member[0]', []);
    const promoCTA = _.get(promoLeadContent, 'ctaText', '');
    const promoLink = _.get(promoLeadContent, 'url', '');
    if (!inline || !items) return null;
    const anonymousProcessor = item => {
      const isMobile = breakpoint === SITE_PLATFORM_MOBILE;
      const getProcessor = ({ seriesType, videoType }) => {
        if (isSeriesCollection(seriesType)) return seriesCollectionVideoProcessor;
        switch (videoType) {
          case isEpisode(videoType):
            return seriesVideoProcessor;
          case isClip(videoType):
            return clipsVideoProcessor;
          default:
            return seriesVideoProcessor;
        }
      };
      const url = helperGetRelativeUrl({ url: item.screenUrl });
      const processor = getProcessor({ seriesType, videoType: item.videoType });
      return {
        ...processor({ item }),
        ...(isMobile && { metadata: null }),
        anonymousCTAText: promoCTA,
        anonymousCTAClick: () => promoLink && redirectToExternalUrl(promoLink),
        hasOverlay: false,
        image: _.get(item, 'images.videoList.raw', null),
        isAnonymous: true,
        link: url || promoLink,
        onTileClick: () => {},
        posterImage: _.get(item, 'images.dcg-mark-poster.raw', null),
        subtitle: !isMobile && item.description,
        target: '_self',
        titleLines: 0,
      };
    };
    const carouselProps = {
      addCarouselPlaceholders,
      allowScrollLock,
      applyInlineBackground,
      breakpoint,
      headline,
      isSeriesDetailAnonymous: renderAsAnonymous,
      isInfinite: false,
      isPosters,
      items,
      processor: anonymousProcessor,
      roundArrows,
      showCarouselArrows,
      showTileMetadataOnHover,
      slidesToScroll: isPosters ? posterToScroll : slidesToScroll,
      slidesToShow: isPosters ? posterLimit : carouselLimit,
      theme: isPosters ? CarouselPosterTheme : CarouselTheme,
      tileTheme: CarouselTileTheme,
      useScrollableDiv,
    };
    return (
      <>
        <div className={style.carouselContainer}>
          <Carousel {...carouselProps} />
        </div>
        {renderDivider && (
          <div className={style.dividerContainer}>
            <div className={style.carouselDivider} />
          </div>
        )}
      </>
    );
  }

  renderNoTabContent({ noTabState }) {
    if (noTabState === NO_TAB_STATE_TRAILER) {
      return this.renderPremierePreview();
    }
    return null;
  }

  renderPremierePreview() {
    const { breakpoint, inline } = this.props;
    const hasTrailer = hasPrePremiereVideo(inline);
    const video = _.get(inline, 'items.member.0.previewVideo.member.0', false);
    if (!hasTrailer || video === false) return null;
    const props = prePremiereVideoProcessor({ item: video });
    props.renderImage = image =>
      renderImage({
        breakpoint,
        imageType: SHOW_DETAIL_THUMBNAIL_IMAGE,
        ...image,
      });

    return (
      <div className={style.premierePreview}>
        <Tile {...props} />
      </div>
    );
  }

  renderPromoItemContent({ item }) {
    const { accessToken, deviceId, pageViewEvent, tabs, seriesType } = this.props;
    const { isPersonality } = this.state;
    const url = _.get(item, 'url');
    const promoContentType = _.split(url, '/').shift();
    const containerId = isPersonality
      ? getPersonalityTabSlug({ tab: item, tabs, seriesType })
      : getTabSlug({ tab: item, tabs, seriesType });
    let scrollElement;

    switch (promoContentType) {
      case PAGE_TYPE_ARTICLE: {
        if (tabs.length > 0) scrollElement = ARTICLE_SCROLL_ELEMENT;
        const articleUrl = getArticleApiUrl(url);
        return (
          <Article
            containerId={containerId}
            url={articleUrl}
            accessToken={accessToken}
            deviceId={deviceId}
            pageViewEvent={pageViewEvent}
            theme={articleTheme}
            scrollElement={scrollElement}
            seriesType={seriesType}
          />
        );
      }
      case PROMO_TYPE_GALLERY:
        return (
          <PhotoGalleryComponent
            accessToken={accessToken}
            data-test="photo-gallery"
            deviceId={deviceId}
            url={url}
          />
        );
      default:
        return null;
    }
  }

  renderPromoList() {
    const {
      params: { showId, pageType, pageId },
      accessToken,
      deviceId,
      pageViewEvent,
      setLoading,
    } = this.props;
    if (!pageId || pageType !== PAGE_TYPE_PROMO_LIST) return null;

    const promoListUrl = getPromoListApiUrl(pageId);
    return (
      <div className={style.screen}>
        <div className={style.promoScreen}>
          <PromoList
            url={promoListUrl}
            accessToken={accessToken}
            deviceId={deviceId}
            pageViewEvent={pageViewEvent}
            setErrors={this.setErrors}
            setLoading={setLoading}
            showId={showId}
          />
        </div>
      </div>
    );
  }

  renderSingleTabContent({
    item,
    highlightFirstVideo,
    renderFirstTile,
    isAuthenticated,
    preauthorizedResources,
  }) {
    if (isPromoItem(item)) return this.renderPromoItemContent({ item });
    if (isCreditsItem(item)) return this.renderCredits();

    const {
      accessToken,
      account,
      adblock,
      anonymousId,
      anonymousLogin,
      authCheckComplete,
      authSuccess,
      breakpoint,
      deviceId,
      latestEpisode,
      inline,
      isLatestEpisodeLive,
      mvpdData,
      openSignIn,
      openSignUp,
      profileId,
      provider,
      renderAuthContainer,
      saveLiveVideo,
      setAccountCloseIgnoreRedirect,
      setIsAuthenticated,
      setIsPlayerLoaded,
      seriesData,
      setAuthorizationToken,
      setMVPDToAppState,
      setMVPDLogoutDataToAppState,
      setOverlay,
      setProvider,
      tabs,
      toggleMvpdAuthOverlay,
    } = this.props;
    const { isPersonality, scrolling } = this.state;
    let url = getTabDataUrl(item);
    const originalVideos = _.get(item, 'items.member', null);
    const videos =
      originalVideos &&
      originalVideos.map(video =>
        Object.assign({ isAuthenticated, preauthorizedResources }, video),
      );
    const videoCount = _.get(item, 'items.totalItems', null);
    const seriesType = this.getSeriesType();
    if (videos) {
      if (videoCount === 0) return null;
      url = null;
    }
    const playlistId = this.getPlaylistId();
    const tabSlug = isPersonality
      ? getPersonalityTabSlug({ tab: item, tabs, seriesType, isPersonality })
      : getTabSlug({ tab: item, tabs, seriesType });
    const latestEpisodeSeason = _.get(latestEpisode, 'seasonNumber');
    const itemSeason = _.get(item, 'seasonNumber');
    const isItemSeasonLatestSeason = itemSeason === latestEpisodeSeason;
    const liveLatestEpisode = isLatestEpisodeLive && isItemSeasonLatestSeason && latestEpisode;

    const videoModalProps = {
      accessToken,
      account,
      adblock,
      anonymousId,
      anonymousLogin,
      authCheckComplete,
      authSuccess,
      breakpoint,
      deviceId,
      openSignIn,
      openSignUp,
      profileId,
      provider,
      renderAuthContainer,
      setAccountCloseIgnoreRedirect,
      setAuthorizationToken,
      setIsAuthenticated,
      setIsPlayerLoaded,
      setInterval,
      setOverlay,
      setMVPDToAppState,
      setMVPDLogoutDataToAppState,
      setProvider,
    };
    return (
      <VideosTabComponent
        accessToken={accessToken}
        account={account}
        authCheckComplete={authCheckComplete}
        authSuccess={authSuccess}
        breakpoint={breakpoint}
        deviceId={deviceId}
        highlightFirstVideo={highlightFirstVideo}
        inline={inline}
        isAuthenticated={isAuthenticated}
        isPersonality={isPersonality}
        key={url || item.id}
        latestEpisode={latestEpisode}
        liveLatestEpisode={liveLatestEpisode}
        mvpdData={mvpdData}
        playlist={playlistId}
        preauthorizedResources={preauthorizedResources}
        renderFirstTile={renderFirstTile}
        saveLiveVideo={saveLiveVideo}
        scrolling={scrolling}
        seriesData={seriesData}
        seriesType={seriesType}
        setOverlay={setOverlay}
        tab={item}
        tabName={_.get(item, 'name')}
        tabSlug={tabSlug}
        tabs={tabs}
        toggleMvpdAuthOverlay={toggleMvpdAuthOverlay}
        url={url}
        videoModalProps={videoModalProps}
        videos={videos}
      />
    );
  }

  renderSocialLinks(shouldRender) {
    const { breakpoint, inline } = this.props;
    const { socialLinks } = BREAKPOINTS[breakpoint];
    if (!shouldRender || !socialLinks) return null;
    const inlineContent = _.get(inline, 'items.member.0', null);
    if (!inlineContent) return null;
    const links = getSocialLinksFromContent(inlineContent);
    const socialLinkComponent = _.map(links, link => {
      if (!link) return null;
      return (
        <Link
          key={`key-${link.url}`}
          className={style.socialLink}
          to={link.url}
          target="_blank"
          rel={LINK_REL}
        >
          <img src={link.icon} alt={link.name} />
        </Link>
      );
    });
    return <div className={style.socialLinkContainer}>{socialLinkComponent}</div>;
  }

  renderTabContent({
    tabs,
    tabIndex,
    subTabIndex,
    isAuthenticated,
    preauthorizedResources,
    pageType,
  }) {
    const { isPersonality } = this.state;
    if (tabIndex === false) return null;
    let item = tabs[tabIndex];
    if (!item) return null;
    if (subTabIndex !== false) item = _.get(item, `children.${subTabIndex}`, item);
    const tabType = _.get(item, '@type', null);
    const seriesType = this.getSeriesType();
    const personalityTabSlug = getPersonalityTabSlug({
      tab: item,
      tabs,
      seriesType,
      isPersonality,
    });
    if (pageType === PAGE_TYPE_PROMO_LIST) {
      return this.renderPromoList();
    }

    if (tabType === 'Biography') {
      return PersonalityBio({ item, style, personalityTabSlug });
    }

    if (seriesType === SERIES_TYPE_SERIES_COLLECTION) {
      return this.renderSingleTabContent({
        item,
        highlightFirstVideo: false,
        isAuthenticated,
        preauthorizedResources,
        style,
      });
    }

    if (SeasonPagesEnabled) {
      const isFirstTab = tabIndex === 0;
      const highlightFirstVideo = isPersonality || isTabGrouped({ tabType, seriesType });
      return this.renderSingleTabContent({
        item,
        renderFirstTile: isFirstTab,
        highlightFirstVideo,
        isAuthenticated,
        preauthorizedResources,
        style,
      });
    }

    if (!isPersonality && !isTabGrouped({ tabType, seriesType })) {
      return this.renderSingleTabContent({
        item,
        highlightFirstVideo: false,
        isAuthenticated,
        preauthorizedResources,
        style,
      });
    }

    let renderFirstTile = true;
    return tabs.map(tab => {
      const type = _.get(tab, '@type', null);
      if (type !== tabType && !isPersonality) return null;
      const renderedTab = this.renderSingleTabContent({
        item: tab,
        highlightFirstVideo: true,
        renderFirstTile,
        isAuthenticated,
        preauthorizedResources,
        style,
      });
      renderFirstTile = false;
      return renderedTab;
    });
  }

  renderTabs() {
    const pageId = this.getPageId();
    const {
      params: { showId, pageType },
      tabs,
      inline,
      setOverlay,
      breakpoint,
      overlay,
      seriesData,
      pageViewEvent,
      isAuthenticated,
      preauthorizedResources,
      seriesType: utagSeriesType,
    } = this.props;
    const { isBrandingClicked, isPersonality, playlist } = this.state;
    if (!tabs) return null;

    const seriesType = this.getSeriesType();
    const noTabState = this.noTabState();
    const noTabHomepage = this.noTabHomepage();
    const { actionButtonsInNav } = BREAKPOINTS[breakpoint];
    const { tabIndex, subTabIndex } = this.getCurrentTabIndex();

    let tabContent = null;
    if (noTabState) {
      tabContent = this.renderNoTabContent({ noTabState, isAuthenticated, preauthorizedResources });
    }

    if (!tabIndex && pageType === PAGE_TYPE_ARTICLE) {
      tabContent = this.renderArticle();
    }

    if (!tabContent) {
      tabContent = this.renderTabContent({
        tabs,
        tabIndex,
        subTabIndex,
        isAuthenticated,
        preauthorizedResources,
        pageType,
      });
    }
    return (
      <div className={classNames(['container', style.screenElement])}>
        <TabListComponent
          {...{
            breakpoint,
            favoriteButton: this.renderFavorite(FAVORITE_TYPE_LINK),
            inline,
            isBrandingClicked,
            isPersonality,
            noTabHomepage,
            noTabState,
            overlay,
            pageId,
            pageType,
            pageViewEvent,
            playlist,
            seriesData,
            seriesType,
            setIsBrandingClicked: this.setIsBrandingClicked,
            setOverlay,
            showId,
            socialLinks: this.renderSocialLinks(true),
            subTabIndex: subTabIndex === false ? null : subTabIndex,
            tabIndex,
            tabs,
            togglePlaylist: this.togglePlaylist,
            utagSeriesType,
          }}
          className={style.tabListNav}
          showActionButtons={actionButtonsInNav}
        />
        <div className={style.tabContent}>
          {this.renderFeaturedPromo()}
          {tabContent}
        </div>
      </div>
    );
  }

  renderSeriesDetail() {
    const {
      breakpoint,
      errors,
      inline,
      removeVideoHero,
      seriesData,
      setLoading,
      setVideoHero,
      tabs,
    } = this.props;

    const { isPersonality, renderAsAnonymous } = this.state;
    if (renderAsAnonymous) return null;

    const contentPersonality = _.get(seriesData, 'categoryTags');
    const showId = _.get(inline, '@id', '');
    const paramShowId = _.get(this.props, 'params.showId', '');
    const isCategoriesDetail = _.get(this.props, 'route.params.fetchFromCategories');
    const isSameShowAsTheUrlParam = showId.indexOf(paramShowId) !== -1;
    const showLoader = (!isCategoriesDetail && !isSameShowAsTheUrlParam) || (!inline && !tabs);

    const { backgroundVideoLoops } = window.ExternalConfig;
    if (errors) return getErrorComponent(errors);
    if (showLoader) return <Loader data-test="loader" setLoading={setLoading} center />;
    if (contentPersonality) setSegmentContentPersonality(contentPersonality);
    const breadcrumbsData = this.getBreadcrumbsData();
    // SEO: prevent TVSeries schema type from displaying on personalities
    const getSchema = isPersonality ? null : createSeriesDetailSchema;

    return (
      <div className={style.screenShows}>
        <VideoHero
          backgroundVideoLoops={backgroundVideoLoops}
          id="show-bg"
          {...this.getVideoHeroProps()}
          className={style.videoHero}
          onMount={setVideoHero}
          onUnmount={removeVideoHero}
          renderImage={image =>
            renderImage({
              breakpoint,
              imageType: SHOW_DETAIL_HERO_IMAGE,
              ...image,
            })
          }
        />
        <StickyContainer>
          {setHelmetTags(this.getSEO())}
          {setHelmetTags({
            tags: [createSchemaTag({ item: seriesData, getSchema })],
          })}
          {this.setOverrideMetatags()}
          {this.renderInline()}
          <Element name={SERIES_SCROLL_ELEMENT}>{this.renderTabs()}</Element>
        </StickyContainer>
        <BreadcrumbsComponent data={breadcrumbsData} />
      </div>
    );
  }

  renderSeriesDetailAnonymous() {
    const { breakpoint, disableScroll, promos, seriesData, tabs } = this.props;
    const { contextPlayerVisibility, isPersonality, renderAsAnonymous } = this.state;
    if (!renderAsAnonymous) return null;
    const getSchema = isPersonality ? null : createSeriesDetailSchema;
    const onCloseModal = () => {
      this.setState({ contextPlayerVisibility: false }, () =>
        disableScroll({ disableScroll: false, bodyOnly: false }),
      );
    };
    const video = _.get(seriesData, 'previewVideo.member.0', null);
    if (video) video.isTrailer = true;
    const hasPromos = !_.isEmpty(promos);
    const title = _.get(video, 'name', '');
    const isMobile = breakpoint === SITE_PLATFORM_MOBILE || breakpoint === SITE_PLATFORM_TABLET;
    const promoLeadData = getPromoData({ data: promos, promoType: PROMO_TYPE_LEAD });
    const promoLeadContent = _.get(promoLeadData, 'items.member[0]', []);
    const promoImage = _.get(seriesData, 'images.seriesList.raw');
    const promoLink = _.get(promoLeadContent, 'url', '');
    const promoDescription = _.get(promoLeadContent, 'description', '');
    const promoCTA = _.get(promoLeadContent, 'ctaText', '');
    const promoProps = {
      promoImage,
      promoLogo: '/static/images/nation-logo-230x70.png',
      promoDescription,
      promoCTA,
    };
    const onClickCTA = () => promoLink && redirectToExternalUrl(promoLink);
    const hasLoadedContent = seriesData;
    if (!hasLoadedContent) return <Loader />;

    return (
      <div className={classNames(style.screenShows)}>
        {setHelmetTags(this.getSEO())}
        {setHelmetTags({
          tags: [createSchemaTag({ item: seriesData, getSchema })],
        })}
        {this.setOverrideMetatags()}
        {this.renderInline()}
        {hasLoadedContent && <HeadlineBumper promos={promos} />}
        {tabs &&
          tabs.map((panel, index) => {
            const displayTemplate = _.get(panel, 'displayTemplate');
            const isPoster = displayTemplate === 'featured';
            const isClips = _.get(panel, 'videoTypes', []).includes('clip');
            if (isClips) return null;
            return this.renderPanel(panel, isPoster, index !== tabs.length - 1);
          })}
        {hasLoadedContent && hasPromos && <NationWhatIs promos={promos} />}
        {hasLoadedContent && hasPromos && <StartFreeTrial promos={promos} />}
        <ContextPlayer
          isMobile={isMobile}
          onClickCTA={onClickCTA}
          onClose={onCloseModal}
          promo={promoProps}
          title={title}
          visibility={contextPlayerVisibility}
          video={video}
        />
      </div>
    );
  }

  render() {
    return (
      <>
        {this.renderSeriesDetailAnonymous()}
        {this.renderSeriesDetail()}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    calendar: state.seriesDetail.calendar,
    continueWatching: state.seriesDetail.continueWatching,
    favoritableItems: state.seriesDetail.favoritableItems,
    errors: state.seriesDetail.errors,
    id: state.seriesDetail.id,
    inline: makeSelectSeriesDetailInline(state),
    promos: makeSelectSeriesDetailPromos(state),
    seo: makeSelectSeriesDetailSeo(state),
    seriesData: makeSelectSeriesDetailSeriesData(state),
    seriesType: state.seriesDetail.seriesType,
    tabs: makeSelectSeriesDetailTabs(state),
    latestEpisode: makeSelectSeriesDetailLatestEpisode(state),
    recommendationIdData: state.app.recommendationIdData,
    isLatestEpisodeLive: state.seriesDetail.isLatestEpisodeLive,
    articlePanels: state.article.panels,
    bioProfiles: state.bio.profiles,
  };
}

SeriesDetail.contextTypes = {
  router: PropTypes.shape({}),
};

SeriesDetail.defaultProps = {
  accessToken: null,
  account: null,
  adblock: false,
  anonymousId: null,
  articlePanels: null,
  authCheckComplete: false,
  authSuccess: false,
  bioProfiles: null,
  continueWatching: null,
  deviceId: null,
  disableScroll: noop,
  errors: null,
  favoritableItems: [],
  favoritesManager: {},
  inline: [],
  isAuthenticated: false,
  isHeader: null,
  isLatestEpisodeLive: null,
  latestEpisode: null,
  mvpdData: null,
  openSignIn: noop,
  openSignUp: noop,
  overlay: null,
  preauthorizedResources: [],
  profileId: null,
  promos: null,
  provider: null,
  recommendationId: null,
  recommendationIdData: null,
  renderAuthContainer: noop,
  route: {},
  seo: null,
  seriesData: null,
  seriesType: null,
  setAccountCloseIgnoreRedirect: noop,
  setIsAuthenticated: noop,
  setIsPlayerLoaded: noop,
  setLoading: null,
  setMVPDLogoutDataToAppState: noop,
  setMVPDToAppState: noop,
  setProvider: noop,
  setRecommendationId: noop,
  tabs: [],
  toggleMvpdAuthOverlay: noop,
};

SeriesDetail.propTypes = {
  accessToken: PropTypes.string,
  account: PropTypes.shape({}),
  adblock: PropTypes.bool,
  anonymousId: PropTypes.string,
  anonymousLogin: PropTypes.func.isRequired,
  articlePanels: PropTypes.shape({}),
  authCheckComplete: PropTypes.bool,
  authSuccess: PropTypes.bool,
  bioProfiles: PropTypes.shape({}),
  breakpoint: PropTypes.string.isRequired,
  clearSeriesDetail: PropTypes.func.isRequired,
  continueWatching: PropTypes.arrayOf(PropTypes.shape({})),
  deviceId: PropTypes.string,
  disableScroll: PropTypes.func,
  errors: PropTypes.number,
  favoritableItems: PropTypes.arrayOf(PropTypes.shape({})),
  favoritesManager: PropTypes.shape({
    favorites: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    setFavorites: PropTypes.func.isRequired,
    deleteFavorites: PropTypes.func.isRequired,
  }),
  fetchCategoryDetail: PropTypes.func.isRequired,
  fetchAnonymousCategoryDetail: PropTypes.func.isRequired,
  fetchAnonymousSeries: PropTypes.func.isRequired,
  fetchSeries: PropTypes.func.isRequired,
  getUseUtagGlobal: PropTypes.func.isRequired,
  inline: PropTypes.shape({}),
  isAuthenticated: PropTypes.bool,
  isHeader: PropTypes.bool,
  isLatestEpisodeLive: PropTypes.bool,
  latestEpisode: PropTypes.shape({}),
  mvpdData: PropTypes.shape({}),
  openSignIn: PropTypes.func,
  openSignUp: PropTypes.func,
  overlay: PropTypes.string,
  pageViewEvent: PropTypes.func.isRequired,
  params: PropTypes.shape({
    showId: PropTypes.string,
  }).isRequired,
  preauthorizedResources: PropTypes.arrayOf(PropTypes.string),
  profileId: PropTypes.string,
  promos: PropTypes.arrayOf(PropTypes.shape({})),
  provider: PropTypes.func,
  recommendationId: PropTypes.string,
  recommendationIdData: PropTypes.oneOfType([PropTypes.node, PropTypes.shape({})]),
  removeVideoHero: PropTypes.func.isRequired,
  renderAuthContainer: PropTypes.func,
  route: PropTypes.shape({}),
  saveLiveVideo: PropTypes.func.isRequired,
  seo: PropTypes.shape({}),
  seriesData: PropTypes.shape({}),
  seriesType: PropTypes.string,
  setAccountCloseIgnoreRedirect: PropTypes.func,
  setAuthorizationToken: PropTypes.func.isRequired,
  setInterval: PropTypes.func.isRequired,
  setIsAuthenticated: PropTypes.func,
  setIsPlayerLoaded: PropTypes.func,
  setLoading: PropTypes.func,
  setMVPDLogoutDataToAppState: PropTypes.func,
  setMVPDToAppState: PropTypes.func,
  setOverlay: PropTypes.func.isRequired,
  setProvider: PropTypes.func,
  setRecommendationId: PropTypes.func,
  setSeriesDetailError: PropTypes.func.isRequired,
  setVideoHero: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.shape({})),
  toggleMvpdAuthOverlay: PropTypes.func,
};

SeriesDetail.fetchData = ({ store, params, location, accessToken }) => {
  const { pathname } = location;
  const { showId, pageType, pageId } = params;
  const pathNameParts = pathname.split('/');
  if (pathNameParts[1] === 'personalities') {
    return store.dispatch(fetchCategoryDetail(showId, accessToken));
  }

  return store
    .dispatch(dispatch => dispatch(fetchSeries(showId, accessToken)))
    .then(async response => {
      const panels = _.get(response, 'payload.data.panels.member', null);
      if (!panels) return null;
      if (pageType === 'article') {
        const articleUrl = getArticleApiUrl(pageId);
        return store.dispatch(fetchArticle(articleUrl, accessToken));
      }
      if (pageType === 'credits') {
        return store.dispatch(fetchBioLanding(showId, accessToken)).then(() => {
          if (pageId) {
            const showBrandingPanel = _.find(panels, isInlineComponent);
            const credits = _.get(showBrandingPanel, 'items.member.0.credits.member', []);
            const creditId = getCreditIdFromUrl({ credits, pageId });
            if (creditId) return store.dispatch(fetchBioDetail(creditId, accessToken));
          }
          return null;
        });
      }
      const tabComponents = panels.filter(
        elem => !isInlineComponent(elem) && !isContinueWatchingComponent(elem),
      );
      const tabItems = _.get(tabComponents, '0.items.member', null);
      if (!tabItems) return null;

      const inlineComponent = panels.find(isInlineComponent);
      const hasTrailer = hasPrePremiereVideo(inlineComponent);
      const trailer = _.get(inlineComponent, 'items.member.0.previewVideo.member.0', false);
      const noTabHomepage = hasTrailer && trailer && trailer.name ? NO_TAB_STATE_TRAILER : null;
      const calculatedPageId = pageType && pageId ? `${pageType}/${pageId}` : pageId || pageType;
      const noTabState = !calculatedPageId && noTabHomepage ? noTabHomepage : null;
      const seriesType = _.get(inlineComponent, 'items.member.0.seriesType', null);
      const { tabIndex } = getSelectedTabIndex({
        pageId: calculatedPageId,
        tabs: tabItems,
        noTabState,
        noTabHomepage,
        seriesType,
      });
      const selectedTab = tabItems[tabIndex];
      if (!selectedTab) return null;

      const url = getTabDataUrl(selectedTab);
      const tabId = selectedTab['@id'];
      if (url) {
        return store.dispatch(fetchVideosTab({ url, accessToken })).then(response => {
          const responseData = _.get(response, 'payload.data', null);
          if (responseData) store.dispatch(setFirstPage(responseData, tabId));
        });
      }
      return store.dispatch(setFirstPage(selectedTab, tabId));
    });
};

const TimeoutShow = ReactTimeout(
  connect(mapStateToProps, {
    fetchAnonymousCategoryDetail,
    fetchAnonymousSeries,
    fetchSeries,
    fetchCategoryDetail,
    clearSeriesDetail,
    saveLiveVideo,
    setRecommendationId,
    setSeriesDetailError,
  })(SeriesDetail),
);

TimeoutShow.fetchData = SeriesDetail.fetchData;

export default TimeoutShow;
